<template>
    <div>
        <v-dialog
            :persistent="!confirmedClose"
            @click:outside="initCloseModal(false)"
            v-model="showModal"
            max-width="550px"
        >
            <v-card>
                <v-card-title>Tribute Editor Settings</v-card-title>

                <v-card-text>
                    <span>
                        General settings that apply to the tribute editor.
                    </span>

                    <v-divider></v-divider>

                    <p>Sets the maximum number of photos to be used in this tribute</p>
                    <v-text-field
                        outlined
                        label="Maximum Photos"
                        color="#ff7837"
                        class="p-0 m-0"
                        v-model="settings.maxItems"
                        type="number"
                    />
                    <p class="text-right"><router-link class="font-weight-bold" :to="{ name: 'Settings', query: { tab: 'general'}}">Edit default photo limit for all tribute videos</router-link>.</p>

                </v-card-text>
                <pre>{{tmpSettings}}</pre>
                <v-card-actions class="d-flex justify-end">
                    <v-btn class="mr-2 no-text-transform" @click="initCloseModal(false)" depressed outlined
                        >Cancel</v-btn
                    >
                    <v-btn
                        class="no-text-transform"
                        :disabled="disableUpdateBtn"
                        :dark="!disableUpdateBtn"
                        @click="saveSettings"
                        :loading="loading"
                        depressed
                        color="#ff7837"
                        >Apply</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="closeWithoutSavingModal" max-width="400">
            <v-card>
                <v-card-title> Close without saving? </v-card-title>
                <v-card-text> Click confirm to close without saving changes. </v-card-text>

                <v-card-actions class="d-flex justify-end">
                    <v-btn class="no-text-transform" outlined @click="closeWithoutSavingModal = false" depressed
                        >Cancel</v-btn
                    >
                    <v-btn class="no-text-transform" @click="confirmCloseWithoutSaving" depressed color="error"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </div>
</template>
<script>
import moment from 'moment';
import TributeVideoService from '@/services/tributeVideo.service';
// import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import CustomTooltip from '../../ui/CustomTooltip.vue';

export default {
    data() {
        return {
            settings: {
                maxItems: 400
            },
            tmpSettings: null,
            confirmedClose: false,
            loading: false,
            showModal: false,
        };
    },
    inject: ['state'],
    components: { CustomTooltip },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        tributeVideo() {
            return this.$store.state.tributeVideo;
        },
        disableUpdateBtn() {
            return this.hasChangesToSave || this.loading;
        },
        hasChangesToSave() {
            return false;
        }
    },
    filters: {
    },
    watch: {
    },
    methods: {
        ...mapActions(['showSnackbar']),
        initApiService() {
            if (this.state.token && !this.api) {
                this.api = TributeVideoService(this.state.token)
            }
        },
        async open() {
            this.initApiService();
            this.showModal = true;
            // TODO: verify the correct request for settings 
            const settingsReq = await this.api.getSettings(this.tributeVideo.id);
            const { data } = settingsReq;
            if (data) {
                const { maxItems } = data;
                this.settings.maxItems = maxItems;
            }
        },
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const response = await this.$auth.getIdTokenClaims();
                this.token = response.__raw;
            }
        },
        initCloseModal(skipConfirm) {
            if (skipConfirm || this.confirmedClose) {
                this.confirmedClose = true;
                this.showModal = false;
            } else {
                this.showModal = false;
            }
        },
        confirmCloseWithoutSaving() {
            this.closeWithoutSavingModal = false;
            this.showModal = false;
        },
        async saveSettings() {
            this.loading = true;
            // Note: this will only work so long as the property names match the server
            const savePayload = { ...this.settings };

            const request = await this.api.updateSettings(this.tributeVideo.id, savePayload)
                .catch(() => {
                    this.showSnackbar({ message: 'Error saving settings'});
                });
            this.loading = false;
            const { data, status } = request;
            if (status === 200) {
                this.$store.dispatch('tributeVideo/updateTributeVideo', {
                    maxItems: data.maxItems
                });
                this.showSnackbar({ message: 'Settings saved.'});
                this.showModal = false;
            }
        }
    },
    async mounted() {
        await this.setAuthToken();
        this.apiService = TributeVideoService(this.token);
    },
};
</script>
<style lang="scss" scoped>
</style>
